import React from 'react';

import { Box } from '@chakra-ui/react';
import { Menu, MenuItem } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { selectMSTeamsContext } from 'selectors/msTeamsSelector';
import styled from 'styled-components';
import { checkDenyPublicCFVisibilityEnabled } from 'utils/helpers/featureFlags';

import { Praise, RequestFeedback, ShareFeedback } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const StyledMenu = styled(Menu)`
  ul {
    padding: 10px;
  }
`;
const StyledMenuItem = styled(MenuItem)`
  padding: 5px 5px;
  border-radius: 4px;

  &:hover {
    color: #104f95;
    background-color: #e6f1fd;

    svg {
      color: #104f95;
    }
  }
`;

const FeedbackMenuOptions = ({ shareFeedback = () => {}, requestFeedback = () => {}, isOpen = false, anchorEl }) => {
  const msTeamsContext = useSelector(selectMSTeamsContext);
  const isMsTeamsView = Boolean(msTeamsContext);
  const isMenuOnTop = isMsTeamsView;
  const handleClose = (e, option, isSharePublicPraise = false) => {
    switch (option) {
      case 'SHARE_PUBLIC_PRAISE':
        shareFeedback(isSharePublicPraise);
        break;
      case 'SHARE_FEEDBACK':
        shareFeedback();
        break;
      case 'REQUEST_FEEDBACK':
        requestFeedback();
        break;
      default:
        break;
    }
  };

  return (
    <StyledMenu
      anchorEl={anchorEl?.current}
      keepMounted
      open={isOpen}
      onClose={handleClose}
      disablePortal
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: isMenuOnTop ? 'top' : 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: isMenuOnTop ? 'bottom' : 'top',
        horizontal: 'right',
      }}
    >
      {!checkDenyPublicCFVisibilityEnabled() && (
        <StyledMenuItem onClick={(e) => handleClose(e, 'SHARE_PUBLIC_PRAISE', true)}>
          <Praise boxSize="24px" fill="transparent" />

          <TextBodyMedium ml={2} color="inherit">
            Share public praise
          </TextBodyMedium>
        </StyledMenuItem>
      )}
      <StyledMenuItem onClick={(e) => handleClose(e, 'SHARE_FEEDBACK')}>
        <ShareFeedback boxSize="24px" />

        <TextBodyMedium ml={2} color="inherit">
          Share feedback
        </TextBodyMedium>
      </StyledMenuItem>

      <StyledMenuItem onClick={(e) => handleClose(e, 'REQUEST_FEEDBACK')}>
        <Box ml="-4px" mt="-4px">
          <RequestFeedback boxSize="24px" />
        </Box>

        <TextBodyMedium ml={3} color="inherit">
          Request feedback
        </TextBodyMedium>
      </StyledMenuItem>
    </StyledMenu>
  );
};

export default FeedbackMenuOptions;
